import { render } from "./VisitorSecuritySettings.vue?vue&type=template&id=8e4a9cf4"
import script from "./VisitorSecuritySettings.vue?vue&type=script&lang=js"
export * from "./VisitorSecuritySettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__